(function () {
  const interactiveSelector = [
    "button",
    "a[href]",
    "input",
    "select",
    "textarea",
    "label",
    "summary",
    "[role='button']",
    "[data-shopify-xr]",
    "open-lightbox-button",
    "carousel-navigation",
    "carousel-prev-button",
    "carousel-next-button",
    ".scroll-marker",
    ".product-zoom-button",
    ".custom-cursor"
  ].join(", ");

  const pointerStartByCarousel = new WeakMap();
  const suppressClickUntilByCarousel = new WeakMap();
  const swipeThreshold = 10;
  const suppressDurationMs = 350;

  function getCarouselFromEvent(event) {
    const target = event.target;

    if (!(target instanceof Element)) {
      return null;
    }

    return target.closest(".product-gallery__carousel");
  }

  function getGalleryFromCarousel(carousel) {
    if (!(carousel instanceof Element)) {
      return null;
    }

    const gallery = carousel.closest("product-gallery");

    if (!gallery || !gallery.hasAttribute("allow-zoom")) {
      return null;
    }

    return gallery;
  }

  function shouldIgnoreTarget(target) {
    return target.closest(interactiveSelector) !== null;
  }

  function getImageIndexFromClickedCell(carousel, clickedCell) {
    const imageCells = Array.from(
      carousel.querySelectorAll(".product-gallery__media[data-media-type='image']")
    ).filter((cell) => !cell.hidden);

    const clickedIndex = imageCells.indexOf(clickedCell);
    return clickedIndex >= 0 ? clickedIndex : null;
  }

  document.addEventListener(
    "pointerdown",
    (event) => {
      const carousel = getCarouselFromEvent(event);
      if (!carousel || !getGalleryFromCarousel(carousel)) {
        return;
      }

      pointerStartByCarousel.set(carousel, { x: event.clientX, y: event.clientY });
    },
    true
  );

  document.addEventListener(
    "pointerup",
    (event) => {
      const carousel = getCarouselFromEvent(event);
      if (!carousel || !getGalleryFromCarousel(carousel)) {
        return;
      }

      const start = pointerStartByCarousel.get(carousel);
      if (!start) {
        return;
      }

      const deltaX = Math.abs(event.clientX - start.x);
      const deltaY = Math.abs(event.clientY - start.y);

      if (deltaX > swipeThreshold || deltaY > swipeThreshold) {
        suppressClickUntilByCarousel.set(carousel, Date.now() + suppressDurationMs);
      }
    },
    true
  );

  document.addEventListener(
    "click",
    (event) => {
      const carousel = getCarouselFromEvent(event);
      if (!carousel) {
        return;
      }

      const gallery = getGalleryFromCarousel(carousel);
      if (!gallery) {
        return;
      }

      const suppressUntil = suppressClickUntilByCarousel.get(carousel) || 0;
      if (Date.now() < suppressUntil) {
        return;
      }

      const target = event.target;
      if (!(target instanceof Element) || shouldIgnoreTarget(target)) {
        return;
      }

      const clickedCell = target.closest(".product-gallery__media");
      if (!clickedCell || clickedCell.getAttribute("data-media-type") !== "image" || clickedCell.hidden) {
        return;
      }

      const imageIndex = getImageIndexFromClickedCell(carousel, clickedCell);

      event.preventDefault();
      event.stopPropagation();

      gallery.dispatchEvent(
        new CustomEvent("lightbox:open", {
          bubbles: true,
          detail: { index: imageIndex }
        })
      );
    },
    true
  );
})();
